<template>
  <div>
    <template v-if="isUploadRef">
      <div id="popup-div" class="alert alert-warning" style="margin-bottom: 50px">
        <h4 style="color: black">You must be logged in to upload a paper on ScholarLib</h4>
        <h6>Please login below or <router-link to="/signup">sign up</router-link></h6>
      </div>
    </template>
    <LoginComponent />
  </div>
</template>

<script>
  import firebase from 'firebase';
import LoginComponent from '@/components/LoginComponent'
  export default {
    data() {
      return {
        isUploadRef: this.$route.query.ref === 'upload'
      }
    },
    components: {
      LoginComponent
    },
  }
</script>

<style>
#popup-div {
  text-align: center;
}
</style>